// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9363 ? "cff4c5fa" : chunkId) + "." + {"2658":"9c51f4adf325bee3","9363":"8712ce7e5d83a72c"}[chunkId] + ".js";
};